import { Box } from "@mui/material";
import { UserThatShareCampaign } from "../../../types/apiTypes";
import { UserPermissionListHeader } from "./UserPermissionListHeader";
import { UserPermissionListRow } from "./UserPermissionListRow";
import { TableColumnType } from "../../../types/genereal";
import { PermissionRoles } from "../../../types/enums";

const values: TableColumnType[] = [
  {
    key: "index",
    minWidth: "48px",
    maxWidth: "48px",
    label: "",
    bgColor: "#E8ECF0",
    textAlign: "left",
  },
  {
    key: "full_name",
    minWidth: "150px",
    maxWidth: "50%",
    label: "Full Name",
    textAlign: "left",
  },
  {
    key: "email",
    minWidth: "150px",
    maxWidth: "50%",
    label: "Email",
    textAlign: "left",
  },
  {
    key: "role",
    minWidth: "100px",
    maxWidth: "200px",
    label: "Assigned Role",
    textAlign: "left",
  },
  {
    key: "permissions",
    minWidth: "150px",
    maxWidth: "200px",
    label: "Manage Permissions",
    textAlign: "center",
  },
];

type Props = {
  users: UserThatShareCampaign[];
  isNoClient?: boolean;
};

const mockPermissions = {
  view: {
    all_pages: { allowed: true, is_modifiable: true },
    account_plans: { allowed: true, is_modifiable: true },
    playbooks: { allowed: true, is_modifiable: true },
    client_lead_info: { allowed: true, is_modifiable: true },
    infuse_lead_info: { allowed: true, is_modifiable: true },
  },
  export: {
    all_reports: { allowed: true, is_modifiable: true },
    playbooks: { allowed: true, is_modifiable: true },
    account_plans: { allowed: true, is_modifiable: true },
    contacts_list: { allowed: true, is_modifiable: true },
  },
  edit: {
    full_functionality: { allowed: true, is_modifiable: true },
    create_campaign: { allowed: true, is_modifiable: true },
    resync_data: { allowed: true, is_modifiable: true },
    target_titles: { allowed: true, is_modifiable: true },
    generate_reports: { allowed: true, is_modifiable: true },
    launch_account_analysis: { allowed: true, is_modifiable: true },
  },
  share: {
    access: { allowed: true, is_modifiable: true },
    view_internal_users: { allowed: true, is_modifiable: true },
    client_view_demo: { allowed: true, is_modifiable: true },
    permissions_management: { allowed: true, is_modifiable: true },
  },
};

const emptyList = [
  {
    user_id: "1",
    email: "--",
    first_name: "--",
    last_name: "",
    avatar_url: "",
    role: PermissionRoles.client,
    permissions: mockPermissions,
    roles: [PermissionRoles.sales],
  },
  {
    user_id: "2",
    email: "--",
    first_name: "--",
    last_name: "",
    avatar_url: "",
    role: PermissionRoles.client,
    permissions: mockPermissions,
    roles: [PermissionRoles.cs],
  },
  {
    user_id: "3",
    email: "--",
    first_name: "--",
    last_name: "",
    avatar_url: "",
    role: PermissionRoles.client,
    permissions: mockPermissions,
    roles: [PermissionRoles.list_gen],
  },
];

export const UserPermissionList = ({ users, isNoClient }: Props) => {
  return (
    <Box>
      <UserPermissionListHeader columns={values} />
      {(users.length === 0 ? emptyList : users).map((user, index) => (
        <UserPermissionListRow
          key={index}
          columns={values}
          row={{
            ...user,
            index: String(index + 1),
            isNoClient: isNoClient ? "" : "client",
          }}
        />
      ))}
    </Box>
  );
};
